import { SectionHead } from "@/components/SectionHead";
import { Reveal } from "@/components/Reveal";
import { InsightTeaserCard } from "@/components/glimpses/Glimpses";

const STATEMENTS = ["What is happening.", "What requires attention.", "What you should do next."];

export const DifferenceSection = () => (
  <section className="section bg-navy" data-testid="difference-section">
    <div className="container-x grid items-center gap-12 lg:grid-cols-12 lg:gap-16">
      <div className="lg:col-span-6">
        <SectionHead dark eyebrow="The ANFORD Difference" title="More than property management." copy="Traditional property-management software helps you record what happened. ANFORD helps you understand:" />
        <Reveal delay={0.15}>
          <ol className="mt-8 space-y-4" data-testid="difference-statements">
            {STATEMENTS.map((s, i) => (
              <li key={s} className="flex items-center gap-4">
                <span className="font-display text-sm font-extrabold text-gold-soft">0{i + 1}</span>
                <span className="font-display text-2xl font-extrabold tracking-tight text-white sm:text-3xl">{s}</span>
              </li>
            ))}
          </ol>
        </Reveal>
      </div>
      <Reveal delay={0.2} className="lg:col-span-6">
        <div className="mx-auto max-w-md">
          <InsightTeaserCard />
        </div>
      </Reveal>
    </div>
  </section>
);
